module.exports = __webpack_public_path__ + "img/inai.d896fdb3.png";